import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  data: [],
  loading: false,
  errorMessage: "",
};

//get gallery
export const fetchGallery = createAsyncThunk(
  `gallery/fetchGallery`,
  async () => {
    const response = await api.get("/gallery/");
    // console.log(response.data);
    return response.data;
  }
);

//post gallery
export const createGallery = createAsyncThunk("", async (data) => {
  const response = await api.post("/gallery/media/", data);
  return response.data;
});

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(fetchGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(fetchGallery.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      // create Notice
      .addCase(createGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(createGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(createGallery.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      });
  },
});

export default gallerySlice.reducer;
